import React from 'react';
import { touch } from 'redux-form/immutable';
import { useDispatch } from 'react-redux';
import RichTextEditor from '../../components/RichTextEditor';

interface ReduxFormInput {
  name: string;
  value?: string;
  onChange: (value: string) => void;
}

interface ReduxFormMeta {
  touched: boolean;
  error?: string;
  form: string;
}

interface FormDescriptionRteFieldProps {
  input: ReduxFormInput;
  label?: string;
  helperText?: string;
  meta: ReduxFormMeta;
  height?: number;
  alwaysDisplayErrors?: boolean;
  disabled?: boolean;
}

const FormDescriptionRteField = ({
  input,
  label,
  helperText,
  meta: { touched, error, form },
  height = 200,
  alwaysDisplayErrors = false,
  disabled = false,
}): FormDescriptionRteFieldProps => {
  const dispatch = useDispatch();

  const handleChange = (value: string): void => {
    if (typeof input.onChange === 'function') {
      input.onChange(value);
    }
  };

  const handleTouch = (): void => {
    dispatch(touch(form, input.name));
  };

  return (
    <RichTextEditor
      value={input.value}
      onChange={handleChange}
      onTouch={handleTouch}
      label={label}
      helperText={helperText}
      height={height}
      error={!!((touched || alwaysDisplayErrors) && error)}
      errorMessage={error}
      disabled={disabled}
    />
  );
};

export default FormDescriptionRteField;
